import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { FirebaseX } from '@ionic-native/firebase-x/ngx';
import { Subscription } from 'rxjs';
import { CrashService } from './crash.service';
import { AuthService, User } from './auth.service';
import * as _ from 'lodash';

@Injectable({
  providedIn: 'root',
})
export class PushService {
  userDataSubscription: Subscription;
  userData: User;
  isDirty: boolean = false;
  changes: User = {};

  fromNotifications: boolean = false;

  constructor(
    private crash: CrashService,
    public firebaseX: FirebaseX,
    public auth: AuthService,
    public router: Router
  ) {
    this.userDataSubscription = this.auth.userData$.subscribe(
      async (userData: User) => {
        console.log(`changed user data to`, userData);
        if (userData && userData.orderRequest) {
          console.log(`have an order status`, userData.orderRequest);
          this.userData = userData;
        } else {
          console.log('Have no purchase requests to process');
        }
      },
      (error: any) => {
        this.crash.subscription('iap-service', 'userDataSubscription', error);
      }
    );
  }

  ngOnDestroy() {
    if (this.userDataSubscription) {
      this.userDataSubscription.unsubscribe();
    }
  }

  // Show the loader for infinite time
  init() {
    console.log('initializing push notifications');

    this.checkNotificationPermission(false);
    this.registerCallbacks();
  }

  async checkNotificationPermission(requested) {
    const hasPermission = await this.firebaseX.hasPermission();
    console.log(`Permission: ${hasPermission}`);
    if (hasPermission) {
      console.log('Remote notifications already have permission');
      this.registerCallbacks();
    } else if (!requested) {
      // Request permission
      console.log('Requesting remote notifications permission');
      await this.firebaseX.grantPermission();
      const granted = await this.firebaseX.hasPermission();
      if (granted) {
        console.log('Remote notifications permission granted');
        this.registerCallbacks();
      } else {
        this.crash.process(
          'push-service',
          'checkNotificationPermission',
          `User denied permission`,
          null
        );
      }
    } else {
      this.crash.process(
        'push-service',
        'checkNotificationPermission',
        `Push notifications are denied`,
        null
      );
    }
  }

  registerCallbacks() {
    this.firebaseX
      .getToken()
      .then((token) => {
        console.log(`got token ${token}`);
        // save the token server-side and use it to push notifications to this device
        this.updateUserToken(token, 'get');
      })
      .catch((error) => console.error('Error getting token', error));

    this.firebaseX
      .onMessageReceived()
      // direct the user to notifications page
      .subscribe((data) => {
        console.log('push received', data);
        this.router.navigate(['/notifications']);
      });

    this.firebaseX.onTokenRefresh().subscribe((token: string) => {
      console.log(`token refreshed ${token}`);
      this.updateUserToken(token, 'refresh');
    });
  }

  async updateUserToken(newToken, source) {
    console.log(`Got a new token ${newToken} from '${source}'`);
    await this.auth.setPushToken(newToken);
  }
}
